import React from "react";
import Modal from "react-modal";
import { AxiosResponse } from "axios";
import { connect } from "react-redux";

import TIMES from "app/consts/TIMES";
import {
  IRecordRequest,
  IMasterRecord,
  IMaster,
  IService,
  IRecordResponse
} from "app/api/types";

import AddRecordForm from "app/components/AddRecordForm";
import EditRecordForm from "app/components/EditRecordForm";
import Cell, { CellTypes } from "./components/Cell";
import {
  Notification,
  INotificationType
} from "app/components/Elements/Notification";

import "./styles.scss";

interface IProps {
  master: IMasterRecord;
  masterList?: IMaster[];
  date: string;
  isLoading: boolean;
  serviceList: IService[];
  getRecords: (date: IRecordRequest["date"]) => Promise<AxiosResponse>;
  addRecord: (data: IRecordRequest) => Promise<AxiosResponse>;
  delRecord: (id: number) => Promise<AxiosResponse>;
  editRecord: (data: IRecordRequest) => Promise<AxiosResponse>;
}

interface IState {
  isDeleting: boolean;
  modalIsOpen: boolean;
  notification: { type: INotificationType; message: string };
  cellInfoIndex: number; // Если ячейка пустая хранит timeStartIndex, иначе хранит recordId
}

const initialNotification = {
  type: INotificationType.NONE,
  message: ""
};

Modal.setAppElement("#root");

class RecordColumn extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isDeleting: false,
      modalIsOpen: false,
      notification: initialNotification,
      cellInfoIndex: -1
    };
  }

  openModal = (id: number) => {
    this.setState({
      cellInfoIndex: id,
      modalIsOpen: true
    });
  };

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
      notification: {
        type: INotificationType.NONE,
        message: ``
      }
    });
  };

  addRecord = (data: IRecordRequest) => {
    this.props
      .addRecord(data)
      .then(() => {
        this.closeModal();
        this.setState({
          modalIsOpen: false,
          notification: {
            type: INotificationType.SUCCESS,
            message: `Запись создана`
          }
        });
        this.props.getRecords(this.props.date);
      })
      .catch(err =>
        this.setState({
          notification: {
            type: INotificationType.ERROR,
            message: `Ошибка: ${err[0].msg}`
          }
        })
      );
  };

  editRecord = (data: IRecordRequest) => {
    this.props
      .editRecord(data)
      .then(() => {
        this.closeModal();
        this.setState({
          modalIsOpen: false,
          notification: {
            type: INotificationType.SUCCESS,
            message: `Изменения сохранены`
          }
        });
        this.props.getRecords(this.props.date);
      })
      .catch(err =>
        this.setState({
          notification: {
            type: INotificationType.ERROR,
            message: `Ошибка: ${err[0].msg}`
          }
        })
      );
  };

  delRecord = (id: number) => {
    this.setState({
      isDeleting: true
    });

    this.props.delRecord(id).then(() => {
      this.closeModal();
      this.setState({
        modalIsOpen: false
      });

      this.props.getRecords(this.props.date);
    });
  };

  renderCells = () => {
    let cells = [];

    for (let i = 0; i < TIMES.length - 1; i++) {
      const timeStartIndex = i;
      const record:
        | IRecordResponse
        | undefined = this.props.master.records.find(
        el => el?.time_start === TIMES[i]
      );

      const type: CellTypes = record
        ? record.is_accepted
          ? CellTypes.ACCEPTED
          : CellTypes.CREATED
        : CellTypes.EMPTY;

      if (!!record) {
        for (let j = i; j < TIMES.indexOf(record.time_end); j++) {
          cells.push(
            <Cell
              timeStartIndex={timeStartIndex}
              recordId={record.id}
              key={`${record.id}-${j}`}
              type={type}
              onClick={this.openModal}
            />
          );
        }

        const nextI = TIMES.indexOf(record.time_end) - 1;
        i = nextI > i ? nextI : i;
      } else {
        cells.push(
          <Cell
            timeStartIndex={timeStartIndex}
            recordId={-1}
            key={i}
            type={type}
            onClick={this.openModal}
          />
        );
      }
    }

    return cells;
  };

  takeFullDay = () => {
    const data = {
      masterId: this.props.master.masterid,
      timeStart: TIMES[0],
      timeEnd: TIMES[TIMES.length - 1],
      serviceIds: [],
      date: this.props.date,
      customerName: "занят весь день",
      customerPhone: " ",
      isAccepted: true
    };

    this.props.addRecord(data).then(() => {
      this.setState({
        isDeleting: false,
        notification: {
          type: INotificationType.SUCCESS,
          message: `Изменения сохранены`
        }
      });
      this.props.getRecords(this.props.date);
    });
  };

  renderModal = () => {
    const record =
      this.props.master.records[0] !== null &&
      this.props.master.records.find(el => el.id === this.state.cellInfoIndex);

    return (
      <Modal
        isOpen={this.state.modalIsOpen}
        onRequestClose={this.closeModal}
        contentLabel="Add phrase modal"
        className="user-group__modal"
        overlayClassName="user-group__overlay"
        onAfterClose={() => this.setState({ isDeleting: false })}
      >
        <div
          className={`modal-container ${record ? "" : "record-modal-table"} ${
            this.state.isDeleting ? "deleting" : ""
          }`}
        >
          <div className="phrase-wrapper">
            <div className="left-block">
              <div className="phrase-text" onClick={this.closeModal}>
                закрыть
              </div>
            </div>

            {record && (
              <div className="right-block">
                <p
                  className="phrase-del"
                  onClick={() => this.delRecord(this.state.cellInfoIndex)}
                >
                  удалить
                </p>
              </div>
            )}
          </div>

          {record && (
            <EditRecordForm
              record={record}
              serviceList={this.props.serviceList}
              masterList={this.props.masterList || []}
              onSubmit={this.editRecord}
              isActive={this.state.modalIsOpen}
            />
          )}

          {!record && (
            <AddRecordForm
              record={{
                masterId: this.props.master.masterid,
                timeStart: TIMES[this.state.cellInfoIndex],
                timeEnd: TIMES[this.state.cellInfoIndex],
                customerName: "",
                customerPhone: "",
                date: this.props.date,
                isAccepted: false,
                serviceIds: []
              }}
              serviceList={this.props.serviceList}
              masterList={this.props.masterList || []}
              onSubmit={this.addRecord}
              isActive={this.state.modalIsOpen}
            />
          )}
        </div>
      </Modal>
    );
  };

  render() {
    const recordAmount = this.props.master.records.filter(el => el !== null)
      .length;

    if (this.props.isLoading) return <></>;

    return (
      <div className="record-content">
        <div className="content-header">
          <div className="header-description">
            <p className="description__name">{this.props.master.name}</p>
            <p className="description__position">
              {this.props.master.position}
            </p>
          </div>
          {recordAmount === 0 && (
            <button className="header__full-day" onClick={this.takeFullDay}>
              занять день
            </button>
          )}
        </div>

        <div className="content-cells">{this.renderCells()}</div>

        {this.state.modalIsOpen && this.renderModal()}
        {this.state.notification.message && (
          <Notification
            type={this.state.notification.type}
            message={this.state.notification.message}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    masterList: state.masters.masterList
  };
};

export default connect(mapStateToProps, null)(RecordColumn);
